import { render, staticRenderFns } from "./FindTeacherButton.vue?vue&type=template&id=d4dbc1e0&"
import script from "./FindTeacherButton.vue?vue&type=script&lang=ts&"
export * from "./FindTeacherButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports